import useAuthenticate from '../../components/authentication/authenticate';
import MBalanceTransactions from './MBalanceTransactions';
import RBalanceTransactions from './RBalanceTransactions';

const BalanceTransactions = () => {
  const { user, isLoading } = useAuthenticate();

  if (isLoading) return <div>Loading...</div>;

  const role = Object.keys(user?.user?.active || {})[0]; // 'manager', 'owner', 'tenant', etc.

  if (role === 'manager') {
    return <MBalanceTransactions />;
  } else if (role === 'owner' || role === 'tenant') {
    return <RBalanceTransactions />;
  }
};

export default BalanceTransactions;
